import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import messages from 'routes/App/Apps/MonitorsAndAlerts/translate'
import TableMultiSelect from 'components/common/Form/TableMultiSelect'
import { FilterIcon } from 'helpers/customIcons'
import {
  fetchCriteriaList,
  fetchIndicatorList,
  setActiveCriteria,
  setActiveIndicators,
  setIncludeLevelLower,
} from 'reducers/monitorsAndAlerts/reducer'

class Filters extends Component {
  componentDidMount() {
    this.props.fetchIndicatorList()
  }

  shouldComponentUpdate(nextProps) {
    const {
      activeLicensee,
      activeSite,
      activeLocus,
      includeLevelLower,
    } = nextProps

    if (
      this.props.activeLicensee !== activeLicensee ||
      this.props.activeSite !== activeSite ||
      this.props.activeLocus !== activeLocus ||
      this.props.includeLevelLower !== includeLevelLower
    ) {
      const params = {}

      if (activeSite.get('id') !== 0) {
        params.site = activeSite.get('id')
      }

      if (activeLocus.get('id') !== 0) {
        params.locus = activeLocus.get('id')
      }

      if (includeLevelLower) {
        params.include_level_lower = 1
      }

      this.props.fetchCriteriaList(params)

      return false
    }

    return true
  }

  render() {
    const {
      intl: { formatMessage },
      indicatorList,
      activeIndicators,
      indicatorsLoader,
      setActiveIndicators,
      lang,
    } = this.props
    const spanish = lang === 'es' && 'spanish'

    return (
      <div className={cn('ma-filters', { spanish })}>
        <TableMultiSelect
          name="indicators"
          label={formatMessage(messages.indicators)}
          data={indicatorList.toArray()}
          value={activeIndicators.toArray()}
          onClose={setActiveIndicators}
          loader={indicatorsLoader}
          disabled={indicatorList.size === 0}
          SelectIcon={FilterIcon}
          lang={lang}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          disableUnderline
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    criteriaList: state.getIn(['monitorsAndAlerts', 'criteriaList']),
    indicatorList: state.getIn(['monitorsAndAlerts', 'indicators']),
    criteriaLoader: state.getIn(['monitorsAndAlerts', 'criteriaLoader']),
    indicatorsLoader: state.getIn(['monitorsAndAlerts', 'indicatorsLoader']),
    activeCriteria: state.getIn(['monitorsAndAlerts', 'activeCriteria']),
    activeIndicators: state.getIn(['monitorsAndAlerts', 'activeIndicators']),
    activeLicensee: state.getIn(['monitorsAndAlerts', 'activeLicensee']),
    activeSite: state.getIn(['monitorsAndAlerts', 'activeSite']),
    activeLocus: state.getIn(['monitorsAndAlerts', 'activeLocus']),
    includeLevelLower: state.getIn(['monitorsAndAlerts', 'includeLevelLower']),
    showIncludeLevelLowerCheckbox: state.getIn([
      'monitorsAndAlerts',
      'showIncludeLevelLowerCheckbox',
    ]),
    lang: state.getIn(['locale', 'lang']),
  }),
  {
    fetchCriteriaList,
    fetchIndicatorList,
    setActiveCriteria,
    setActiveIndicators,
    setIncludeLevelLower,
  },
)(injectIntl(Filters))
